<template>
  <nav
    class="flex w-full items-center justify-between px-6 h-20 bg-white text-gray-700 border-b border-gray-200 z-40"
    @keyup.enter="showModal=false"
  >
    <div class="flex items-center">
      <NuxtLink to="/">
        <nav-logo class="h-20" />
      </NuxtLink>
    </div>
    <div class="flex items-center">
      <t-dialog
        v-model:open="showModal"
        variant="search"
      >
        <t-dialog-content class="bg-white">
          <nav-search-nav/>
        </t-dialog-content>
      </t-dialog>
      <div class="lg:hidden flex justify-between bg-transparent">
        <button
          class="flex items-center leading-loose hover:opacity-75"
          @click="showModal=true"
        >
          <t-icon
            name="search"
            class="mx-2 text-text-secondary hover:text-primary-120 text-2xl"
            style="cursor: pointer;"
          />
        </button>
        <nuxt-link
          to="/cart"
          class="flex items-center leading-loose hover:opacity-75">
          <t-icon
            name="shopping-cart"
            class="mx-2 text-text-thirdary hover:text-primary-120 text-2xl"
            style="cursor: pointer;" />
        </nuxt-link>
        <button
          class="mr-2"
          aria-label="Open Menu"
          @click="drawer">
          <t-icon
            name="bars"
            class="mx-2 text-text-thirdary hover:text-primary-120 text-2xl"
            style="cursor: pointer;" />
        </button>
      </div>
    </div>

    <transition
      enter-class="opacity-0"
      enter-active-class="ease-out transition-medium"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-active-class="ease-out transition-medium"
      leave-to-class="opacity-0"
    >
      <div
        v-show="isOpen"
        class="z-10 fixed inset-0 transition-opacity"
        @keydown.esc="isOpen = false"
      >
        <div
          class="absolute inset-0 bg-black opacity-50"
          tabindex="0"
          @click="isOpen = false"
        />
      </div>
    </transition>
    <aside
      class="transform bg-background-thirdary top-0 left-0 w-96 fixed h-full overflow-auto ease-in-out transition-all duration-300 z-30"
      :class="isOpen ? 'translate-x-0' : '-translate-x-full'"
    >
      <div class="px-10 py-4 bg-background-thirdary">
        <div>
          <div class="py-4 block no-underline text-white flex justify-between">
            <nav-white-logo class="w-16" />
            <button
              class=" text-white"
              @click="drawer">
              X
            </button>
          </div>
        </div>
        <div class="py-4">
          <div
            v-if="auth.loggedIn === true"
            class="flex justify-between">
            <t-button
              variant="ctaPrimary"
              class="w-full"
              @click="$router.push('/account'); drawer();">
              My Account
              <t-icon
                name="sign-in-alt"
                class="ml-1 text-white"
                style="cursor: pointer;" />
            </t-button>
          </div>
          <t-button
            variant="ctaPrimary"
            class="w-full"
            @click="$router.push('/login'); drawer();"
          >
            <strong>Sign In <t-icon name="sign-in-alt" /></strong>
          </t-button>
        </div>
        <nav-mobile-nav-items title="Explore Courses">
          <div>
            <nuxt-link
              id="professions"
              to="/profession"
              class="nav-second-level professions"
              @click="drawer(); sendEvent('nav-second-level', 'professions', 'professions', 'professions', '/profession' )"
            >
              <label class=" text-white text-xs">Professions</label>
            </nuxt-link>
            <div
              v-for="(course, i) in navItems.course.professions"
              :key="i"
              class="text-white">
              <a
                :id="course.id"
                :href="course.link"
                :class="course.id"
                class="nav-third-level block py-2 text-base text-white transition duration-150 ease-in-out"
                role="menuitem"
                @click="drawer(); sendEvent('nav-third-level', course.title, course.id, course.id, course.link )"
              >
                {{ course.title }}
              </a>
            </div>
          </div>
        </nav-mobile-nav-items>
        <nav-mobile-nav-items title="Certification Series">
          <div>
            <nuxt-link
              to="/certification-series"
              class="nav-second-level">
              <button
                id="certification-series"
                class="certification-series block text-left w-full py-2 text-base transition duration-150 ease-in-out border-none "
                @click="drawer(); sendEvent('nav-second-level', 'certification-series', 'certification-series', 'certification-series', '/certification-series' )"
              >
                Certification Series
              </button>
            </nuxt-link>
          <!--          <nuxt-link to="/ce-acceleration-virtual-conference">-->
          <!--            <button-->
          <!--              class="block  w-full px-2 py-3 text-sm leading-5 text-white text-left transition duration-150 ease-in-out border-none hover:bg-blue-200 focus:outline-none focus:bg-blue-200"-->
          <!--              @click.native="drawer"-->
          <!--            >-->
          <!--              2024 CE Webathon-->
          <!--            </button>-->
          <!--          </nuxt-link>-->
          </div>
        </nav-mobile-nav-items>
        <nav-mobile-nav-items title="Stroke Symposium 2025">
          <div>
            <nuxt-link
              to="/signature-series/stroke-symposium/nashville-july-2025"
              class="nav-second-level">
              <button
                id="stroke-symposium"
                class="stroke-symposium block text-left w-full py-2 text-base transition duration-150 ease-in-out border-none "
                @click="drawer(); sendEvent('nav-second-level', 'stroke-symposium', 'stroke-symposium', 'stroke-symposium', 'stroke-symposium' )"
              >
                Stroke Symposium 2025
              </button>
            </nuxt-link>
          </div>
        </nav-mobile-nav-items>
        <nav-mobile-nav-items title="Explore Course Formats">
          <div>
            <nuxt-link
              id="formats"
              class="nav-second-level formats"
              to="/formats"
              @click="drawer(); sendEvent('nav-second-level', 'formats', 'formats', 'formats', '/formats' )"
            >
              <label class="text-sm">Formats</label>
            </nuxt-link>
            <div
              v-for="(course, i) in navItems.course.formats"
              :key="i">
              <a
                :id="course.id"
                :href="course.link"
                :class="course.id"
                class="nav-third-level block py-2 text-base text-white transition duration-150 ease-in-out "
                role="menuitem"
                @click="drawer(); sendEvent('nav-third-level', course.title, course.id, course.id, course.link )"
              >
                {{ course.title }}
              </a>
            </div>
          </div>
        </nav-mobile-nav-items>
        <nav-mobile-nav-items title="Explore Courses by Topic">
          <div>
            <nuxt-link
              id="topics"
              to="/topics"
              class="topics nav-second-level"
              @click="drawer(); sendEvent('nav-second-level', 'topics', 'topics', 'topics', '/topics' )"
            >
              <label class="text-sm text-white">Topics</label>
            </nuxt-link>
            <div
              v-for="(course, i) in navItems.course.topics"
              :key="i">
              <a
                :id="course.id"
                :href="course.link"
                class="nav-third-level block py-2 text-base text-white transition duration-150 ease-in-out "
                role="menuitem"
                :class="course.id"
                @click="drawer(); sendEvent('nav-third-level', course.title, course.id, course.id, course.link )"
              >
                {{ course.title }}
              </a>
            </div>
          </div>
        </nav-mobile-nav-items>
        <nav-mobile-nav-items title="Instructors">
          <div>
            <nuxt-link
              id="instructors"
              to="/instructor/directory"
              class="nav-second-level instructors"
              @click="drawer(); sendEvent('nav-second-level', 'instructors', 'instructors', 'instructors', '/instructor/directory' );"
            >
              <label class="text-sm text-white">Instructors</label>
            </nuxt-link>
            <div
              v-for="(instructor, i) in navItems.instructors"
              :key="i"
              class="text-white">
              <a
                :id="instructor.id"
                :href="instructor.link"
                :class="instructor.id"
                class="nav-third-level block py-2 text-base text-white transition duration-150 ease-in-out "
                role="menuitem"
                @click="drawer(); sendEvent('nav-third-level', instructor.title, instructor.id, instructor.id, instructor.link );"
              >
                {{ instructor.title }}
              </a>
            </div>
          </div>
        </nav-mobile-nav-items>
        <nav-mobile-nav-items title="Subscriptions">
          <div>
            <div
              v-for="(subscription, i) in navItems.subscription"
              :key="i">
              <nuxt-link
                :id="subscription.id"
                :to="subscription.link"
                :class="subscription.id"
                class="nav-third-level block 4 py-2 text-base text-white transition duration-150 ease-in-out "
                role="menuitem"
                @click="drawer(); sendEvent('nav-third-level', subscription.title, subscription.id, subscription.id, subscription.link )"
              >
                {{ subscription.title }}
              </nuxt-link>
            </div>
          </div>
        </nav-mobile-nav-items>
        <nav-mobile-nav-items title="Solutions for Teams">
          <div>
            <div
              v-for="(groupSale, id) in navItems.groupSales.ceSolutions"
              :key="id">
              <nuxt-link
                :id="groupSale.id"
                :class="groupSale.id"
                :to="groupSale.link"
                class="nav-third-level block py-2 text-base text-white transition duration-150 ease-in-out "
                role="menuitem"
                @click="drawer(); sendEvent('nav-third-level', groupSale.title, groupSale.id, groupSale.id, groupSale.link )"
              >
                {{ groupSale.title }}
              </nuxt-link>
            </div>
            <div class="pt-4">
              <nuxt-link
                to="#"
                @click="drawer();">
                <label class="text-sm text-white">Solutions By Setting</label>
              </nuxt-link>
            </div>
            <div
              v-for="(groupSale, id) in navItems.groupSales.settings"
              :key="id">
              <nuxt-link
                :id="groupSale.id"
                :class="groupSale.id"
                :to="groupSale.link"
                class="nav-third-level block py-2 text-base leading-5 text-white transition duration-150 ease-in-out "
                role="menuitem"
                @click="drawer(); sendEvent('nav-third-level', groupSale.title, groupSale.id, groupSale.id, groupSale.link )"
              >
                {{ groupSale.title }}
              </nuxt-link>
            </div>
          </div>
        </nav-mobile-nav-items>
        <div class="grid grid-cols-2 grid-rows-auto gap-x-10 py-4">
          <div>
            <nuxt-link
              to="/about"
              class="text-white text-sm"
              @click="drawer();">
              About Summit
            </nuxt-link>
          </div>
          <div>
            <a
              href="https://app.monstercampaigns.com/c/rsyjmmiae38taepi7fqs/"
              class="text-white text-sm">
              Get in touch
            </a>
          </div>
          <div>
            <nuxt-link
              to="/support"
              class="text-white text-sm">
              Customer Support
            </nuxt-link>
          </div>
          <div>
            <nuxt-link
              to="/support"
              class="text-white text-sm">
              FAQ
            </nuxt-link>
          </div>
          <div>
            <a
              href="https://d2vu1vyohnm3g3.cloudfront.net/documents/summit-w9.pdf"
              target="_blank"
              class="text-white text-sm">
              Summit W-9
            </a>
          </div>
          <div>
            <a
              href="https://d2vu1vyohnm3g3.cloudfront.net/documents/spe-attendee-registration-form.pdf"
              target="_blank"
              class="text-white text-sm">
              Registration Form
            </a>
          </div>
        </div>
      </div>
    </aside>
  </nav>
</template>

<script>
import navItems from '@/data/navigationItems.json';
import { navClick, } from '@/services/gtmManager';

export default {
  name: 'MobileNav',
  setup() {
    const { $auth: auth } = useNuxtApp();
    return { auth };
  },
  data() {
    return {
      navItems,
      isOpen: false,
      showModal: false,
    };
  },
  watch: {
    isOpen: {
      immediate: true,
      handler(isOpen) {
        if (import.meta.client) {
          if (isOpen) {
            document.body.style.setProperty('overflow', 'hidden');
          }
          else {
            document.body.style.removeProperty('overflow');
          }
        }
      },
    },
  },
  mounted() {
    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27 && this.isOpen) {
        this.isOpen = false;
      }
    });
  },
  methods: {
    drawer() {
      this.isOpen = !this.isOpen;
    },
    onClickChild() {
      this.showModal = false;
    },
    sendEvent(eventName, linkClick, linkId, linkClass, linkUrl) {
      navClick(this.$gtm, eventName, linkClick, linkId, linkClass, linkUrl);
    },
  },
};
</script>
